<template>
	<div id="xl-banner">
	    <div class="swiper-container">
		    <div class="swiper-wrapper">
						<div class="swiper-slide"><a href="http://www.xianlaigame.com/#/NewsInfoALY"><img src="../images/banner_04.jpg"/></a></div>
		        <div class="swiper-slide"><a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.mahjong.sichuang"><img src="../images/banner_01.jpg"/></a></div>
		        <div class="swiper-slide"><a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.xianlai.mahjonghn"><img src="../images/banner_02.png"/></a></div>
		        <div class="swiper-slide"><a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.xianlai.mahjonggd"><img src="../images/banner_03.png"/></a></div>
		    </div>
		    <!-- 如果需要分页器 -->
		    <div class="swiper-pagination"></div>

		    <!-- 如果需要导航按钮 -->
		    <div class="swiper-button-prev"></div>
		    <div class="swiper-button-next"></div>
		</div>
	</div>
</template>
<script type="text/javascript">
import '../untils/swiper.min.css'
// import '../untils/swiper.min.js'
export default{
	data () {
		return {

		}
	},
	mounted() {
		var mySwiper = new Swiper ('.swiper-container', {
		    loop: true,
		    autoplay: 2000,
		    autoplayDisableOnInteraction : false,
		    roundLengths : true,
		    // 如果需要分页器
		    pagination: '.swiper-pagination',
		    paginationClickable :true,
		    // 如果需要前进后退按钮
		    nextButton: '.swiper-button-next',
		    prevButton: '.swiper-button-prev'

		  })
	  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// Banner.vue?406747e4